import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    main: {
      display: 'flex',
      alignItems: 'center',
    },
    alertmessage: {
      display: 'flex',
      borderRadius: '4px',
      margin: '0 auto',
      width: '600px',
      background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F44336',
    },
    alertContainer: {
      display: 'flex',
      padding: '18px',
      minHeight: 'calc(100vh - 106px)',
      justifyContent: 'center',
      alignItems: 'center',
    },
    alertboxes: {
      width: '600px',
      margin: '40px',
      display: 'flex',
      flexDirection: 'column',
    },
    alertbox: {
      display: 'flex',
      padding: '8px 18px',
    },
    alertIcon: {
      marginRight: '10px',
      color: '#F44336',
    },
    alertTitle: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 600,
      color: '#621b16',
    },
    alertContent: {
      marginTop: '4px',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      color: '#621b16',
    },
    containers: {
      height: '100vh',
      backgroundPosition: 'bottom, left top',
      backgroundRepeat: 'repeat-x, repeat',
      backgroundSize: 'contain, cover',
    },
  }),
  {
    index: 1,
  }
);
